import {takeLatest} from 'redux-saga/effects'
import {getShifts, createShift, removeShift, updateShift, getShiftAppointments} from 'redux/slices/shiftSlice'
import {
  handleCreateShift,
  handleDeleteShifts,
  handleEditShifts,
  handleShiftsGet,
  handleGetShiftAppointments
} from '../handlers/shiftHandler'


const campaignShiftSaga = [
  takeLatest(getShifts.type, handleShiftsGet),
  takeLatest(createShift.type, handleCreateShift),
  takeLatest(removeShift.type, handleDeleteShifts),
  takeLatest(updateShift.type, handleEditShifts),
  takeLatest(getShiftAppointments, handleGetShiftAppointments),
]

export default campaignShiftSaga;
